/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Onboarding_Too_Much_To_ReadInputs */

const en_mobile_onboarding_too_much_to_read = /** @type {(inputs: Mobile_Onboarding_Too_Much_To_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have too much to read`)
};

const es_mobile_onboarding_too_much_to_read = /** @type {(inputs: Mobile_Onboarding_Too_Much_To_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tengo demasiado por leer`)
};

/**
* | output |
* | --- |
* | "I have too much to read" |
*
* @param {Mobile_Onboarding_Too_Much_To_ReadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_onboarding_too_much_to_read = /** @type {((inputs?: Mobile_Onboarding_Too_Much_To_ReadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Onboarding_Too_Much_To_ReadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_onboarding_too_much_to_read(inputs)
	return en_mobile_onboarding_too_much_to_read(inputs)
});